module.exports = __webpack_public_path__ + "img/return-white.d93628f9.png";